import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']
const bgColor = (props) => props.theme.global.colors['background-back']
const linkColor = "#2E6B9E"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`

export const Heading = styled.h1`
  font-size: 16px;
  color: ${darkColor};
  font-weight: 500;
  margin: 0 0 16px;
`

export const List = styled.div`
  padding: 12px;
  max-height: 48px;
  border-radius: 4px;
  border: 1.5px solid ${darkColor};
  background-color: ${bgColor};
  cursor: default;
`

export const ChangeAnswerCTA = styled.button`
  font-family: 'Roboto';
  font-size: 16px;
  color: ${darkColor};
  font-weight: 500;
  margin: 0 0 16px;
  background-color: transparent;
  border: none;
  color: ${linkColor};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-decoration: underline;
  margin: 16px 0 0;
  padding: 0;
  text-align: left;
  cursor: pointer;
`
